import ComplaintHandlingPolicy from "./complaint-handling-policy.page";

export default ComplaintHandlingPolicy;
